import FloatCentDisplayer from "./FloatCentDisplayer";
import type { BanqueLine2 } from "compta-shared";
import DateDisplayerComp from "../../utils/components/DateDisplayerComp.tsx";
import ModeBadge from "./ModeBadge.tsx";

type DepenseLineProps = {
  selected: boolean;
  onVentiler: (id: string) => void;
  showTypeBadge?: boolean;
} & BanqueLine2;

const DepenseLine = (props: DepenseLineProps) => {
  const montantCent = props.montantCent;
  const { selected, date, libelle, onVentiler, _id, type, showTypeBadge } =
    props;
  return (
    <li
      className={
        "row d-flex list-group-item" + " " + (selected ? "active" : "")
      }
    >
      {date ? (
        <div className="col-2">
          <DateDisplayerComp date={date} />{" "}
        </div>
      ) : (
        ""
      )}
      <div className={showTypeBadge ? "col-4" : "col-3"}>
        <div>{libelle}</div>
        {showTypeBadge ? <ModeBadge mode={type} className="mt-1" /> : null}
      </div>
      <div className="col-1">
        {" "}
        <FloatCentDisplayer cent={montantCent} />
      </div>
      <div className="col-1">
        <span
          className={"badge bg-secondary"}
          onClick={onVentiler.bind(null, _id)}
          color="secondary"
          style={{ cursor: "pointer" }}
        >
          Ventiler
        </span>
      </div>
    </li>
  );
};

export default DepenseLine;
